import { ButtonProps } from '../../atoms/Button';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';

type SearchBarInternalProps = {
  icon?: IconProps;
  text?: TextProps;
  button?: ButtonProps;
};

type SearchBarPropsValues = {
  'Filled': SearchBarInternalProps;
  'Unfilled': SearchBarInternalProps;
};

const propValues: SearchBarPropsValues = {
  'Filled': {
    icon: {
      asset: 'Search',
      colour: 'IconInteractive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
  },
  'Unfilled': {
    icon: {
      asset: 'Search',
      colour: 'IconInteractive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
  },
};

const getProps = (type: string): SearchBarInternalProps => {
  const values: SearchBarInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
